import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';


@NgModule({
  imports: [
    MatDialogModule,
    MatMenuModule,
    MatTabsModule,
    MatSelectModule,
    MatRippleModule,
    MatRadioModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatIconModule,
    MatSnackBarModule
  ],
  exports: [
    MatDialogModule,
    MatMenuModule,
    MatTabsModule,
    MatSelectModule,
    MatRippleModule,
    MatRadioModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatIconModule,
    MatSnackBarModule
  ],
})
export class AngularMaterialModule {}
